import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { takeUntil } from "rxjs/operators";
import { Workplace } from "../../../models/base-info/workplace.model";

@Component({
  selector: "ngx-workplace-form",
  templateUrl: "./workplace-form.component.html",
  styleUrls: ["./workplace-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkplaceFormComponent extends BaseFormComponent<Workplace> {
  public apiName: string = "Workplace";
  public label: string = "محل خدمت";
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    super.ngOnInit();
  }
  setMaxCode() {
    this.httpCommonService
      .getMaxCode(this.apiName)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (!this.model) this.model = <Workplace>{};
        if (data) {
          this.model["Code"] = data as number;
        }
        this.setFormGroup(this.model);
      });
  }
}
